import { getGlobalHeaders } from '~api/common/getHeaders';
import { IPGViewsOffers, IPGRestResponse } from '~api/OffersAPI/IOffersApiSdk';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/OffersService';
import { IUpdateOfferPayload } from '~exported/cart-sidebar-cart-offers/OffersViewController/IOffersViewController';

export const getViewQuery = async (view: string) => {
    const { config } = diContainer.get(serviceNames.configRepository);
    const { brand_id, region_id } = config.config.perlgem || { brand_id: 2, region_id: 0 };
    const queryParams = `brand=${brand_id}&region=${region_id}`;
    const url = `/rest/api/v1_0/offers/search/${view}?${queryParams}`;

    const request = await fetch(url, { method: 'GET', headers: getGlobalHeaders() });
    const result: IPGRestResponse = await request.json();

    return result;
};

export const getViewsQuery = async (views: string[]) => {
    const { config } = diContainer.get(serviceNames.configRepository);
    const { brand_id, region_id } = config.config.perlgem || { brand_id: 2, region_id: 0 };
    const queryParams = `brand=${brand_id}&region=${region_id}`;
    const url = `/rest/api/v1_1/offers/search/${views.toString()}?${queryParams}`;

    const request = await fetch(url, { method: 'GET', headers: getGlobalHeaders() });

    const results: IPGViewsOffers = await request.json();

    return results;
};

export const updateOfferByOfferCode = async ({ offerCode, action }: IUpdateOfferPayload) => {
    const { config } = diContainer.get(serviceNames.configRepository);
    const { brand_id, region_id } = config.config.perlgem || { brand_id: 2, region_id: 0 };
    const queryParams = `brand=${brand_id}&region=${region_id}`;
    const url = `/rest/api/v1_0/cart/offers?offer_codes=${offerCode}&${queryParams}`;

    const request = await fetch(url, { method: action, headers: getGlobalHeaders() });
    const result: IPGRestResponse = await request.json();

    return result;
};

export const getManualOffersByOfferCodeQuery = async (offerCodes: string[]) => {
    const { config } = diContainer.get(serviceNames.configRepository);
    const { brand_id, region_id } = config.config.perlgem || { brand_id: 2, region_id: 0 };
    const parsedCodes = offerCodes.join(',');

    const queryParams = `brand=${brand_id}&region=${region_id}`;
    const url = `/rest/api/v1_0/offers/search?offer_codes=${parsedCodes}&${queryParams}`;

    const request = await fetch(url, { method: 'GET', headers: getGlobalHeaders() });
    const result: IPGRestResponse = await request.json();

    return result;
};
